module.exports = "https://www.niulinkcloud.cn/_next/static/media/icon3.2047953fb3a9844d43d28b823e6d3d1e.png";